export default __webpack_public_path__ + "static/media/paisamigos_logo1.f844643d.png";